var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titlenav"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))])]),(_vm.goShow)?_c('div',{staticClass:"go_img"},[_c('img',{staticClass:"img",attrs:{"src":_vm.url,"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }